import { gql } from 'apollo-boost';

export const setBidsMutationInstance = gql`
    mutation setBidsMutation($input: GdSetBidsInput!, $login: String!) {
        reqId: getReqId
        setBids(input: $input) {
            showConditionIds
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;

export const setAutoBidsMutationInstance = gql`
    mutation setAutoBidsMutation($input: GdSetAutoBidsInput!, $login: String!) {
        reqId: getReqId
        setAutoBids(input: $input) {
            keywordIds
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
        getClientMutationId(input: { login: $login }) {
            mutationId
        }
    }
`;
